export const typeOptions = [
  { value: "CLIENT", label: "Client", className: "text-blue-500" },
  { value: "CLIENT_VENDOR", label: "Vendor", className: "text-violet-700" },
];

export const statusOptions = [
  { value: "completed", label: "Completed", className: "text-green-500" },
  { value: "in-progress", label: "Active", className: "text-blue-500" },
  { value: "on-hold", label: "On Hold", className: "text-yellow-500" },
  { value: "pending", label: "Pending", className: "text-red-500" },
];

export const priorityOptions = [
  { value: "high", label: "High", className: "text-red-500" },
  { value: "medium", label: "Medium", className: "text-yellow-700" },
  { value: "low", label: "Low", className: "text-green-500" },
  { value: "on-hold", label: "On Hold", className: "text-orange-500" },
  { value: "active", label: "Active", className: "text-blue-500" },
];

